"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Add = function Add() {
  return _react2.default.createElement(
    "g",
    { id: "graph-view" },
    _react2.default.createElement("path", {
      d: "M405.673593,158.305629 L405.673593,415 L313.792218,415 L313.979222,158.305629 L405.673593,158.305629 L405.673593,158.305629 Z M204.020779,85 L295.715149,85 L295.715149,415 L204.020779,415 L204.020779,85 Z M94,250.000001 L185.694371,250.000001 L185.694371,415 L94,415 L94,250.000001 Z",
      id: "Shape"
    })
  );
};

exports.default = Add;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/GraphView.js
// module id = 2960
// module chunks = 4